import styled from "styled-components";

import { theme } from "../../themes/themes";
export const Header = styled.div`
  width: 100%;
  height: 60px;
  background: linear-gradient(90deg, ${({ theme }) => theme.primary.purple} 10.12%, ${({ theme }) => theme.primary.purple} 88.5%);
  display: inline-block;
`;

export const Logo = styled.div`
  background: ${({ theme }) => theme.neutral.white};
  border-radius: 50px;
  display: flex;
  justify-content: center;
  width: 90px;
  height: 90px;
  align-items: center;
  position: absolute;
  top: -10px;
  left: -1px;
`;

export const Text = styled.div`
  padding-left: 90px;
  height: 100%;
  display: flex;
  align-items: center;

  font-family: "Noto Sans", sans-serif;
  font-style: normal;
  font-weight: 700;
  font-size: 25px;

  color: ${({ theme }) => theme.neutral.white};
`;
